module.exports = __webpack_public_path__ + "static/media/idp-revise-identification.b42cc0e5.svg";